import React from "react";
import s from "../Calendar.css";
import CalendarCell from "./CalendarCell";
import ListCoverPhoto from "../../../components/ListCoverPhoto/ListCoverPhoto";

class CalendarRow extends React.Component {
  render() {
    const { listing, dates, canScrollLeft } = this.props;

    return (
      <div className={`${s.dFlex} ${s.positionRelative} ${s.minWidth3000}`}>
        <div
          className={`${s.dFlex} ${s.alignItemsCenter}   ${
            s.borderBottomForListing
          }  ${s.listingName} ${
            canScrollLeft ? s.borderEnd : s.borderEndWithTrasprant
          }`}
        >
          <div className={s.listPhotoCover}>
            <div className={s.listPhotoMedia}>
              <a target="_blank" href={`/rooms/${listing.id}/preview`}>
                <ListCoverPhoto
                  className={s.imgResponsive}
                  coverPhoto={listing.coverPhoto}
                  listPhotos={listing.listPhotos}
                  photoType={"x_medium"}
                />
              </a>
            </div>
          </div>
          <div>
            <a
              target="_blank"
              href={`/rooms/${listing.id}/preview`}
              className={s.listingLink}
            >
              {listing.title}
            </a>
          </div>
        </div>

        {dates.map((date, index) => (
          <CalendarCell
            key={date.format("YYYY-MM-DD")}
            date={date}
            listing={listing}
            isLast={index === dates.length - 1}
          />
        ))}
      </div>
    );
  }
}

export default CalendarRow;
